import {Device} from 'epic-fortnite-styles/constants';
import styled, {css} from 'styled-components';

const seasons = {
  ch2s4: css`
    background-color: #000;
  `,
  ch2s5: css`
    background: linear-gradient(0deg, rgba(246, 200, 135, 1) 50%, rgba(190, 90, 62, 1) 50%);
  `,
  ch2s6: css`
    background: rgba(255, 255, 255, 1);
    padding: 4em 0;
    @media screen and ${Device.mobileL} {
      padding-bottom: 0;
    }
  `,
  ch2s7: css`
    @media screen and ${Device.mobileL} {
      padding-bottom: 0;
    }
  `,
};
const BattlePassSection = styled.section<{seasonKey?: string; bgImage?: string}>`
  position: relative;
  z-index: 2;
  padding-top: 6em;
  ${(props) => (props.seasonKey ? seasons[props.seasonKey] : null)}
  ${(props) =>
    props.bgImage
      ? css`
          background-image: url(${props.bgImage});
          background-repeat: no-repeat;
          background-size: cover;
        `
      : null}
`;

export default BattlePassSection;
